import { Button } from '@speaking-coach/ui'
import { todayJstIso } from './access-window'

/** Set both inclusive date endpoints in one URL update, anchored to JST today. */
export function DateRangeShortcuts({search, onChange}: {search: URLSearchParams; onChange: (search: URLSearchParams) => void}): JSX.Element {
  function select(days: number) {
    const toDate = todayJstIso()
    const from = new Date(`${toDate}T00:00:00Z`)
    from.setUTCDate(from.getUTCDate() - days + 1)
    const next = new URLSearchParams(search)
    next.delete('page')
    next.set('fromDate', from.toISOString().slice(0,10))
    next.set('toDate', toDate)
    onChange(next)
  }
  return <div role="group" aria-label="Recent dates (JST)" className="space-y-2">
    <p className="text-caption font-medium">Recent dates (JST)</p>
    <div className="flex flex-wrap gap-2">{[7,30].map(days => <Button key={days} variant="secondary" size="sm" onClick={() => select(days)}>Last {days} days</Button>)}</div>
    <p className="text-caption text-text-secondary">Includes today in JST.</p>
  </div>
}
